import { render, staticRenderFns } from "./MyPoints.vue?vue&type=template&id=373a4366&scoped=true"
import script from "./MyPoints.vue?vue&type=script&lang=js"
export * from "./MyPoints.vue?vue&type=script&lang=js"
import style0 from "./MyPoints.vue?vue&type=style&index=0&id=373a4366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a4366",
  null
  
)

export default component.exports